export default __webpack_public_path__ + "static/media/charity_partners.e15d0146.svg";